module.exports = __webpack_public_path__ + "img/otkritost-mob.d451562c.png";